import type React from 'react'

import { PLAN_PRO3 } from '@/constants/userSubscriptionPlans'
import { useUpgradePlan } from '../../hooks'
import { Buttons } from '../Buttons'
import { Features } from '../Features'
import { PRO_AMOUNT, PRO_PLAN_FEATURES } from './constants'

interface Props {
  activeIndex: number
  onSetActiveSlide: (index: number) => void
}

export const UpgradeToPro: React.FC<Props> = ({
  activeIndex,
  onSetActiveSlide,
}) => {
  const { loading, handleClickAllPlan, handleUpgradePlan } = useUpgradePlan()

  return (
    <>
      <Features
        activeSlide={activeIndex}
        items={PRO_PLAN_FEATURES}
        onClick={onSetActiveSlide}
      />

      <Buttons
        amount={PRO_AMOUNT}
        loading={loading}
        onUpgradeClick={() => {
          handleUpgradePlan(PLAN_PRO3)
        }}
        onAllPlansClick={handleClickAllPlan}
      />
    </>
  )
}
